import { Option } from '@/components/ui/FormFields/FormSelect'
import { format } from 'date-fns'
import { ptBR } from 'date-fns/locale'

/**
 * Formats a number as Brazilian currency (BRL)
 */
export const formatCurrency = (value: number): string => {
  return new Intl.NumberFormat('pt-BR', {
    style: 'currency',
    currency: 'BRL',
  }).format(value)
}

/**
 * Formats a date using Brazilian locale
 */
export const formatDate = (date: Date | string, locale = ptBR): string => {
  return format(new Date(date), 'dd/MM/yyyy', { locale })
}

/**
 * Gets status configuration for property status badges
 */
export const getStatusConfig = (status: string) => {
  const statusMap = {
    active: { color: 'green', label: 'Ativo' },
    inactive: { color: 'red', label: 'Inativo' },
    draft: { color: 'yellow', label: 'Rascunho' },
    hidden: { color: 'gray', label: 'Oculto' },
  } as const

  return (
    statusMap[status as keyof typeof statusMap] || {
      color: 'gray',
      label: status,
    }
  )
}

/**
 * Gets reservation status configuration for badges
 */
export const getReservationStatusConfig = (status: string) => {
  const statusMap = {
    waiting_checkin: { color: 'yellow', label: 'Aguardando check-in' },
    guest_in_house: { color: 'green', label: 'Hóspede na casa' },
    checkout_done: { color: 'blue', label: 'Check-out feito' },
  } as const

  return (
    statusMap[status as keyof typeof statusMap] || {
      color: 'gray',
      label: status,
    }
  )
}

/**
 * Calculates percentage change between two values
 */
export const calculatePercentageChange = (
  current: number,
  previous: number
): number => {
  if (previous === 0) return 0
  return ((current - previous) / previous) * 100
}

/**
 * Formats percentage with one decimal place
 */
export const formatPercentage = (value: number): string => {
  return `${value.toFixed(1)}%`
}

/**
 * Stays Listing Subtypes
 */
export const staysListingSubtypes: Option[] = [
  {
    label: 'Imóvel inteiro',
    value: 'entire_home',
  },
  {
    label: 'Quarto privativo',
    value: 'private_room',
  },
  {
    label: 'Quarto compartilhado',
    value: 'shared_room',
  },
]
